<template lang="pug">
  #top
    .flex
      .box
        .row
          .label お名前
          .text
            v-text-field(v-model="name" maxlength="50" type="text")
        .row
          .label
          .text
            .error {{error_name}}
        .row
          .label 電話番号
          .text
            v-text-field(v-model="tel" maxlength="20" type="text")
        .row
          .label
          .text
            .error {{error_tel}}
        .row
          .label メールアドレス
          .text
            v-text-field(v-model="mailaddress" maxlength="256" type="text")
        .row
          .label
          .text
            .error {{error_mailaddress}}
        .row
          .label お問い合わせ内容
          .text
            v-textarea(v-model="comment")
        .row
          .label
          .text
            .error {{error_comment}}
    .button_area
      button.back_button(@click="go_back") 前の画面に戻る
      button.blue_button(@click="go_mail") メールを送る
</template>

<script lang="js">
import ApiClient from '@/module/api';
import store from '@/store';

export default {
  components: {
  },

  data: () => ({
    name: '',
    tel: '',
    mailaddress: '',
    comment: '',
    error_name: '',
    error_tel: '',
    error_mailaddress: '',
    error_comment: '',
  }),
  computed: {
  },
  created() {
    this.$emit('change_mode', 4);
    if (store.getters.pdfData === '') {
      this.go_back();
    }
  },
  methods: {
    go_back() {
      this.$router.push('/step03');
    },
    async go_mail() {
      if (confirm('こちらでメールを送信しますか？')) {
        this.error_name = '';
        this.error_tel = '';
        this.error_mailaddress = '';
        this.error_comment = '';

        const postParam = store.getters.pdfData;
        postParam.name = this.name;
        postParam.tel = this.tel;
        postParam.mailaddress = this.mailaddress;
        postParam.comment = this.comment;
        const api = new ApiClient();
        const data = await api.post('/mail', postParam);
        if (data.errors != null) {
          if (data.errors.name) {
            this.error_name = data.errors.name[0];
          }
          if (data.errors.tel) {
            this.error_tel = data.errors.tel[0];
          }
          if (data.errors.mailaddress) {
            this.error_mailaddress = data.errors.mailaddress[0];
          }
          if (data.errors.comment) {
            this.error_comment = data.errors.comment[0];
          }
        } else {
          alert('メールを送信しました。');
          this.go_back();
        }
      }
    },
  },
};
</script>

<style lang="sass" scoped>
#top
  display: flex
  flex-direction: column
  width: $max-width
  margin: auto
  padding-bottom: 70px
  .flex
    display: flex
    width: 100%
    .box
      width: 100%
      .row
        display: flex
        justify-content: center
        align-items: center
        width: 100%
        .label
          margin-left: 0px
          width: 190px
          font-size: 20px
        .text
          width: 500px
          input
            width: 100%
        .error
          color: #c00
  .button_area
    justify-content: center
@media screen and (max-width: $break-header)
  #top
    width: auto
    .flex
      .box
        padding: 0 30px
        .row
          flex-direction: column
          justify-content: left
          align-items: end
          .label
            width: auto
          .text
            width: 100%
    .button_area
      flex-direction: column-reverse
      align-items: center
      padding: 0 30px
      button
        width: 100%
        &:last-child
          margin-bottom: 40px

</style>
